import { render, staticRenderFns } from "./BaseRet.vue?vue&type=template&id=670cd02d"
import script from "./BaseRet.vue?vue&type=script&lang=js"
export * from "./BaseRet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports